import { inject as service } from '@ember/service';
import EmberRouter from '@embroider/router';
import config from './config/environment';
import { CDP_SCREEN_NAME_FOR_ROUTE } from '@banking/savings-onboarding-app/utils/signup/cdp-screen-name-for-route';

export default class Router extends EmberRouter {
  location = config.locationType;
  rootURL = config.routerRootURL;

  @service eventstream;
  @service dataApi;

  // eslint-disable-next-line ember/classic-decorator-hooks
  init() {
    super.init();

    this.on('routeDidChange', (transition) => {
      if (transition.isAborted) {
        return;
      }

      // TODO: set page_view_description on opts
      this.eventstream.trackPageView(this.trackingPath);
      if (this.currentRouteName in CDP_SCREEN_NAME_FOR_ROUTE) {
        this.dataApi.track('View Onboarding Funnel Step', {
          feature: 'savings',
          screen_name: CDP_SCREEN_NAME_FOR_ROUTE[this.currentRouteName],
        });
      }
    });
  }

  // returns a path without a leading '/' because EventStreamService will add one
  get trackingPath() {
    // app rootUrl in staging and prod is '/savings/'
    const pathHead = this.rootURL?.replace(/^\//, '') ?? '';
    // Ember Router's currentURL has a leading '/'
    const pathTail = this.currentURL?.replace(/^\//, '');
    return `${pathHead}${pathTail}`;
  }
}

Router.map(function () {
  this.route('signup', function () {
    this.route('index', { path: '/' });
    this.route('two-factor', function () {
      this.route('enroll');
      this.route('sms');
      this.route('google-authenticator');
    });
    this.route('confirm-identity', function () {
      this.route('edit');
      this.route('address');
      this.route('invalid-address');
    });
    this.route('enter-identity-info', function () {
      this.route('address');
      this.route('invalid-address');
    });
    this.route('enter-business-info', function () {
      this.route('address');
      this.route('invalid-address');
    });
    this.route('confirm-business', function () {
      this.route('edit');
      this.route('address');
      this.route('invalid-address');
    });
    this.route('business-type');
    this.route('entity-type');
    this.route('business-management');
    this.route('controlling-individuals');
    this.route('agreement');
    this.route('account-open');
    this.route('automation', function () {
      this.route('splash');
      this.route('withholding');
      this.route('target');
      this.route('success');
      this.route('error');
    });
    this.route('link-external-bank-account', function () {
      this.route('link-with-plaid');
      this.route('import-bank-account');
    });
    this.route('ineligible');
    this.route('locked');
    this.route('please-wait');
    this.route('timeout');
    this.route('errored');
    this.route('in-manual-review');
    this.route('documents-requested');
  });
  this.route('loading');
  this.route('forbidden');
  this.route('catch-all', { path: '/*path' });
});
